import { createFileRoute } from "@tanstack/react-router";

import { AdminGuard } from "@/components/admin/AdminGuard";
import { AdminStrategiesPage } from "@/components/admin/strategies/AdminStrategiesPage";

export const Route = createFileRoute("/admin/strategies")({
  component: AdminStrategiesRoute,
});

function AdminStrategiesRoute() {
  return (
    <AdminGuard>
      <AdminStrategiesPage />
    </AdminGuard>
  );
}
